namespace app.autenticacao {
    "use strict";
    
    export interface IVersao {
        version: string;
    }

    export class VersionService {
        private version: ng.IPromise<string> = null;
        
        /** @ngInject */
        constructor(
            private $http : ng.IHttpService,
            private $q: ng.IQService, ) {}

        loadVersionUser() {
            this.version = this.$http.get('/assets/version.json?ts=' + (new Date().getTime()))
                .then((result:ng.IHttpPromiseCallbackArg<IVersao>) => {
                    return result.data.version;
                }); 
        }

        getVersionUser(): ng.IPromise<string> {
            return this.version;
        }

        getVersionServer(): ng.IPromise<string> {
            return this.$http.get('/assets/version.json?ts=' + (new Date().getTime()))
                .then((result:ng.IHttpPromiseCallbackArg<IVersao>) => {
                    return result.data.version;
                }); 
        }
    }

    angular
        .module("app.autenticacao")
        .service("versionService", VersionService);
}